export default __webpack_public_path__ + "static/media/user.aa788159.svg";